import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

export default class Cart {
  getCartData = () => axios.get('/cart.js');

  changeCartItem = ({
    id,
    variantId,
    quantity,
    isSubscription
  }) => {
    let params = {
      id,
      quantity
    };

    if (isSubscription) {
      params = Object.assign(params, this.subscriptionProperties({ variantId }));
    } else {
      params = Object.assign(params, {
        selling_plan: null,
        properties: {
          _subscription_id: null
        }
      });
    }

    return axios.post('/cart/change.js', params);
  };

  removeCartItem = ({ key }) => axios.post('/cart/change.js', { quantity: 0, id: key });

  subscriptionProperties = ({ variantId }) => {
    const variantData = window.variantDataSelector.getData(variantId);

    return {
      selling_plan: variantData.subscriptionId,
      properties: {
        _subscription_id: variantData.subscriptionId
      }
    };
  };

  addBundle = ({ items }) => {
    const bundleId = uuidv4();
    const params = {
      items: items.map((item) => ({
        ...item,
        properties: {
          bundle_id: bundleId
        }
      }))
    };

    return axios.post('/cart/add.js', params);
  };

  removeBundle = ({ items }) => {
    const params = {
      updates: items.reduce((result, item) => ({ ...result, ...{ [item.key]: 0 }}), {})
    };

    return axios.post('/cart/update.js', params);
  };

  addCartItem = ({ quantity, variantId, isSubscription = false }) => {
    let params = { quantity, id: variantId };

    if (isSubscription) {
      params = Object.assign(params, this.subscriptionProperties({ variantId }));
    }

    return axios.post('/cart/add.js', params);
  };
}
